module.exports = __webpack_public_path__ + "overlook-studios/img/CONCEPT-dragger_death_concept_01.gif";